// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1OW8d","fileBtn":"File_fileBtn__3J2lj","closeBtn":"File_closeBtn__2vCw9","fileSelected":"File_fileSelected__o5uq5","disabled":"File_disabled__2NFaq"};